import { AuthUser } from '@domain/types';

import { isLoginWebview as isLoginWebviewUtil } from '@launcher/helpers/desktop/loginWebview.helper';
import { isDesktopApp, isUsingNewElectron } from '@launcher/utils';
import { i18n } from '@services/i18n';
import { LocalStorage } from '@services/localStorage.service';
import { logger } from '@services/logger/logger.service';
import { authenticateUserSuccess } from '@store/user/user.actions';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

export function useAuthenticateUser() {
  const dispatch = useDispatch();
  const isLoginWebview = useMemo(() => isLoginWebviewUtil(), []);

  return useCallback(
    async (user: AuthUser) => {
      logger.info('LOGIC', 'handleAuthenticationSuccess', {
        email: user.email,
        workspace: user.currentWorkspaceId,
      });

      // Persist email and workspace ID for next connection
      if (user?.email?.length > 0) {
        LocalStorage.set('LIFEN_USER_EMAIL', user.email);

        // Also save email in Electron settings for main process
        if (isDesktopApp() && (await isUsingNewElectron()) && window.electron?.saveUserEmail) {
          logger.info('LOGIC', 'saveUserEmail in Electron settings', {
            email: user.email,
          });
          window.electron.saveUserEmail(user.email);
        }
      }

      if (user?.currentWorkspaceId?.length > 0) {
        LocalStorage.set('WORKSPACE_ID', user.currentWorkspaceId);
      }

      // User data has been dispatched, no more reason to go further
      if (isLoginWebview) {
        return;
      }

      i18n.changeLanguage(user.preferredLocale);

      // Dispatch action to store user data
      dispatch(authenticateUserSuccess(user));
    },
    [dispatch, isLoginWebview],
  );
}
